import React from "react";
import { Link } from "react-router-dom";

import Table from "../common/Table";
import RowPhoto from "../common/TdImg";
import lbl from "../../data/Labels.json";
import ApplicantActions from './ApplicantActions';

const ApplicantsList = ({ data, query, onSaved }) => {
  const columns = [
    { path: "serial", label: "شماره", content: e => (data.page - 1) * data.limit + data.data.indexOf(e) + 1 },
    {
      path: "student_photo",
      label: "عکس",
      content: (e) => <RowPhoto src={e.student_photo} />,
    },
    { path: "aria_id", label: "کد دانشجو" },
    { path: "nexa_id", label: "کد ملی" },
    {
      path: "student_name",
      label: "نام",
      content: (e) => (
        <Link to={`/mis/applicants/${e.student_id}`}>
          {[e.student_name, e.student_lastname].filter(Boolean).join(" ")}
        </Link>
      ),
    },
    { path: "student_father_name", label: "نام پدر" },
    { path: "grand_father_name", label: "نام پدرکلان" },
    { path: "permanent_city", label: "ولایت اصلی" },
    { path: "current_city", label: "ولایت فعلی" },
    { path: "student_phone", label: "شماره تماس" },
    { path: "tazkera_no", label: "شماره تذکره" },
    { path: "school_name", label: "لیسه" },
    { path: "graduation_year", label: "سال فراغت" },
    { path: "entry_year", label: "سال شمولیت" },
    { path: "faculty", label: "فاکولته" },
    { path: "department", label: "دیپارتمنت" },
    { path: "aria_kankor_score", label: "نمره کانکور آریا" },
    {
      path: "registration_complete",
      label: "ثبت نام",
      content: (e) =>
        Number(e.registration_complete) === 1 ? (
          <span>{lbl.ApplicantsComplete}</span>
        ) : (
          <span style={{ color: "red" }}>{lbl.ApplicantsIncomplete}</span>
        ),
    },
    { key:'actions',label:'عملیات',content:e=><ApplicantActions row={e} onSaved={onSaved}/> },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default ApplicantsList;
